import React from 'react';

import { LazyTrashedSpacesPage } from '@confluence/site-settings/entry-points/TrashedSpacesPage.ts';
import { ADMIN_TRASHED_SPACES_ANALYTICS_SOURCE } from '@confluence/site-settings/entry-points/trashedSpacesConstants.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

export const AdminTrashedSpacesRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => <LazyTrashedSpacesPage />;

AdminTrashedSpacesRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: { name: ADMIN_TRASHED_SPACES_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
